/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const sceneLevelTypes = {
    cube: 'cube',
    flat: 'flat',
};